import React from 'react'
import { constructUrl } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import Link from '../link/Link'

const Folder = ({ block }) => {
    const { ID, audience } = block?.attributes

    return (
        <div className="folder-block">
            {block?.content ? (
                <Link isIcon={false} url={constructUrl(ID, audience)}>
                    <span className="baseocom-mb-1 baseocom-mr-1">{icon('arrow-right')}</span>
                    {block?.content}
                </Link>
            ) : (
                block.childrens && (
                    <Parser
                        content_block={block.childrens}
                        attributes={block.attributes}
                        type="link-internal"
                    />
                )
            )}
        </div>
    )
}

export default Folder
